// run-command-prompt-ticket-context-section.ts
//
// The "## Ticket context" section of the worker prompt, split out of
// run-command-prompt-builder.ts to keep that file under the 200-line budget
// (plan 20260924-0205). Pure: same lines, same order as before the split.
import type { Ticket } from "./schemas/ticket-schema.js";

export function renderTicketContextSection(ticket: Ticket, cleanReviewContext: boolean): string[] {
  const lines: string[] = [];
  lines.push("## Ticket context");
  if (cleanReviewContext) {
    // No plan_path/phase_path: those point at the implementing session's
    // own plan and phase notes. Judge the diff against what was ASKED.
    lines.push(
      "- Phiên review CONTEXT SẠCH: bạn KHÔNG được cấp plan_path/phase_path/sổ quyết định của phiên implement. Đây là chủ ý — đánh giá diff theo HỢP ĐỒNG dưới đây, không theo lập luận của người viết code.",
    );
  } else {
    lines.push(`- plan_path: ${ticket.plan_path}`);
    lines.push(`- phase_path: ${ticket.phase_path}`);
  }
  lines.push(
    `- allowed_paths: ${ticket.allowed_paths.length > 0 ? ticket.allowed_paths.join(", ") : "(rỗng — không có phạm vi ghi)"}`,
  );
  lines.push(`- verification_recipe: ${ticket.verification_recipe}`);
  // C1 contract fields. Rendered for EVERY adapter when present (a worker
  // should always know what counts as delivered), and they are the clean
  // reviewer's only framing — hence unconditional rather than gated on
  // `cleanReviewContext`.
  if (ticket.outcome !== undefined) {
    lines.push(`- outcome (kết quả mong đợi): ${ticket.outcome}`);
  }
  if (ticket.acceptance !== undefined && ticket.acceptance.length > 0) {
    lines.push("- acceptance (điều kiện nghiệm thu):");
    for (const row of ticket.acceptance) {
      const evidenceNote = row.evidence === undefined ? "" : ` · evidence: ${row.evidence}`;
      lines.push(`  - [${row.done ? "x" : " "}] ${row.text}${evidenceNote}`);
    }
  }
  if (ticket.coverage_limits !== undefined && ticket.coverage_limits.length > 0) {
    lines.push(
      `- coverage_limits (ticket tự nhận KHÔNG phủ): ${ticket.coverage_limits.join("; ")}`,
    );
  }
  return lines;
}
